import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Authentication.css';
import UserPool from '../../UserPool';
import { CognitoUser, AuthenticationDetails } from 'amazon-cognito-identity-js';
import { useCustomContext } from '../CustomComponents/CustomComponents';
import { FaRegEye, FaRegEyeSlash } from 'react-icons/fa6';
import { jwtDecode } from 'jwt-decode';
import AWS from 'aws-sdk';
import { insertLog } from '../Logs/InsertLog';


function SignIn({ onLogin }) {
    const [email, setEmail] = useState(localStorage.getItem('rememberedEmail') || '');
    const [password, setPassword] = useState(localStorage.getItem('rememberedPassword') || '');
    const [isChecked, setIsChecked] = useState(localStorage.getItem('rememberMe') === 'true');
    const [emailErrorMessage, setEmailErrorMessage] = useState('');
    const [passwordErrorMessage, setPasswordErrorMessage] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();
    const { showAlert, hud, stopHudRotation } = useCustomContext();
    const location = useLocation();


    useEffect(() => {
        window.history.forward();
        const handlebackbutton = () => window.history.forward();
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', handlebackbutton);
        return () => window.removeEventListener('popstate', handlebackbutton);
    }, []);

    AWS.config.update({
        accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
        secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
        region: process.env.REACT_APP_COGNITO_REGION,
    });

    const cognitoISP = new AWS.CognitoIdentityServiceProvider();


    const GoogleCustomattribute = async (username, Name) => {
        const empInfo = {
            name: Name,
            accessLevel: 1,
            isEmployeeApproved: false,
            isEmployeeActive: false,
        };

        try {
            await cognitoISP.adminUpdateUserAttributes({
                UserPoolId: process.env.REACT_APP_COGNITO_USERPOOLID,
                Username: username,
                UserAttributes: [
                    {
                        Name: 'custom:empInfo',
                        Value: JSON.stringify(empInfo),
                    },
                    {
                        Name: 'email_verified', Value: "true"
                    }
                ],
            }).promise();

            console.log('Custom attribute updated successfully');
        } catch (error) {
            console.error('Failed to update custom attributes:', error);
        }
    };

    const getUserDetailsFromCognito = async (cognitoUsername) => {
        try {
            const userData = await cognitoISP.adminGetUser({
                UserPoolId: process.env.REACT_APP_COGNITO_USERPOOLID,
                Username: cognitoUsername,
            }).promise();

            console.log('User Details:', userData);

            const attributes = {};
            userData.UserAttributes.forEach(attr => {
                attributes[attr.Name] = attr.Value;
            });

            const email = attributes.email;
            const empInfo = attributes['custom:empInfo'];
            const parsedEmpInfo = JSON.parse(empInfo);
            const accessLevel = parsedEmpInfo.accessLevel;

            localStorage.setItem('isEmployeeApproved', parsedEmpInfo.isEmployeeApproved);
            localStorage.setItem('isEmployeeActive', parsedEmpInfo.isEmployeeActive);
            localStorage.setItem('employeeName', parsedEmpInfo.name);
            localStorage.setItem('accessLevel', accessLevel);
            localStorage.setItem('UserStatus', userData.UserStatus);
            localStorage.setItem('email', email);
            localStorage.setItem('EmpInfo', empInfo);

            const isApproved = parsedEmpInfo.isEmployeeApproved === 'true' || parsedEmpInfo.isEmployeeApproved === true;
            const isActive = parsedEmpInfo.isEmployeeActive === 'true' || parsedEmpInfo.isEmployeeActive === true;
            const userName = email?.split('@')[0];

            if (isApproved && isActive) {
                insertLog(
                    `${userName} successfully signed in with Google and navigated to home screen.`,
                    0,
                    email,
                    hud,
                    stopHudRotation,
                    showAlert
                );
                return { success: true, email, accessLevel, isApproved, isActive };
            }
            else
            {
                insertLog(
                    `${userName} failed to signed in with Google.`,
                    0,
                    email,
                    hud,
                    stopHudRotation,
                    showAlert
                );
                navigate('/AccessDenied')
            }

            
         
        } catch (error) {
            console.error('Failed to get user details:', error);
            return { success: false, reason: 'Unable to fetch user details.' };
        }
    };

    useEffect(() => {
        const handleOAuth = async () => {
            const queryParams = new URLSearchParams(location.search);
            const code = queryParams.get('code');

            if (!code) return;

            const redirect_uri = "https://refer.sharkunlock.com"; // or your local URI
            //const redirect_uri = "http://localhost:3000"; // or your production URI

            const tokenUrl = 'https://us-east-1z0mtkhk91.auth.us-east-1.amazoncognito.com/oauth2/token';
            const body = new URLSearchParams({
                grant_type: 'authorization_code',
                code,
                redirect_uri: redirect_uri,
                client_id: process.env.REACT_APP_COGNITO_CLIENTID,
            });

            try {
                hud('Please Wait...');
                const res = await fetch(tokenUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body,
                });

                const data = await res.json();

                if (data.access_token) {
                    hud("Please Wait...");
                    const idToken = data.id_token;
                    const decoded = jwtDecode(idToken);
                    const email = decoded.email;
                    const name = decoded.name;
                    const providerSub = decoded.sub;
                    const providerUsername = decoded['cognito:username'];

                    console.log('Cognito Username:', decoded);

                    let usersWithEmail = [];
                    try {
                        const userList = await cognitoISP
                            .listUsers({
                                UserPoolId: process.env.REACT_APP_COGNITO_USERPOOLID,
                                Filter: `email = "${email}"`,
                            })
                            .promise();
                        usersWithEmail = userList.Users || [];
                        console.log('userEmail:', usersWithEmail)
                    } catch (err) {
                        console.error('Error listing users with email:', err);
                    }
                    let finalUsername = providerUsername;

                    if (usersWithEmail.length >= 1) {
                        const nativeUser = usersWithEmail.find(u => u.UserStatus !== 'EXTERNAL_PROVIDER');
                        const googleUser = usersWithEmail.find(u => u.UserStatus === 'EXTERNAL_PROVIDER');

                        if (nativeUser && googleUser) {
                            console.log('🔁 Both native and Google users found.');

                            try {
                                const userData = await cognitoISP.adminGetUser({
                                    UserPoolId: process.env.REACT_APP_COGNITO_USERPOOLID,
                                    Username: nativeUser.Username,
                                }).promise();

                                const identitiesAttr = userData.UserAttributes.find(attr => attr.Name === 'identities');
                                let identities = [];

                                if (identitiesAttr && identitiesAttr.Value) {
                                    identities = JSON.parse(identitiesAttr.Value);
                                }

                                const googleAlreadyLinked = identities.some(id => id.providerName === 'Google');

                                if (googleAlreadyLinked) {
                                    console.log('🔗 Native user already linked with Google. Deleting redundant federated Google user.');
                                    await cognitoISP.adminDeleteUser({
                                        UserPoolId: process.env.REACT_APP_COGNITO_USERPOOLID,
                                        Username: googleUser.Username,
                                    }).promise();
                                    finalUsername = nativeUser.Username;
                                } else if (identities.length >= 5) {
                                    console.warn('⚠️ Cannot link Google: too many linked identities. Deleting redundant federated user.');
                                    await cognitoISP.adminDeleteUser({
                                        UserPoolId: process.env.REACT_APP_COGNITO_USERPOOLID,
                                        Username: googleUser.Username,
                                    }).promise();
                                    finalUsername = nativeUser.Username;
                                } else {
                                    await cognitoISP.adminLinkProviderForUser({
                                        UserPoolId: process.env.REACT_APP_COGNITO_USERPOOLID,
                                        DestinationUser: {
                                            ProviderName: 'Cognito',
                                            ProviderAttributeValue: nativeUser.Username,
                                        },
                                        SourceUser: {
                                            ProviderName: 'Google',
                                            ProviderAttributeName: 'Cognito_Subject',
                                            ProviderAttributeValue: providerSub,
                                        },
                                    }).promise();

                                    console.log('✅ Linked Google account to native user');

                                    await cognitoISP.adminDeleteUser({
                                        UserPoolId: process.env.REACT_APP_COGNITO_USERPOOLID,
                                        Username: googleUser.Username,
                                    }).promise();
                                    console.log('🗑️ Deleted federated Google user after linking');

                                    finalUsername = nativeUser.Username;
                                }
                            } catch (err) {
                                console.error('❌ Error during linking process:', err);
                            }
                        } else if (nativeUser && !googleUser) {
                            console.log('✅ Only native user exists. Using native account.');
                            finalUsername = nativeUser.Username;
                            const emailAttr = nativeUser?.Attributes?.find(attr => attr.Name === 'email');
                            const NativeEmail = emailAttr ? emailAttr.Value : null;
                            console.log("emails:", NativeEmail, email);


                            if (email === NativeEmail) {
                                console.log("values:", NativeEmail, email)
                                try {
                                    // Optional: verify user exists before deleting
                                    const userExists = await cognitoISP.adminGetUser({
                                        UserPoolId: process.env.REACT_APP_COGNITO_USERPOOLID,
                                        Username: providerUsername,
                                    }).promise().catch(() => null);

                                    if (userExists) {
                                        await cognitoISP.adminDeleteUser({
                                            UserPoolId: process.env.REACT_APP_COGNITO_USERPOOLID,
                                            Username: providerUsername,
                                        }).promise();
                                        console.log(`🗑️ Successfully deleted federated Google user: ${providerUsername}`);
                                    } else {
                                        console.log(`ℹ️ Skipped deletion: federated user ${providerUsername} does not exist`);
                                    }
                                } catch (error) {
                                    console.error(`❌ Failed to delete federated Google user: ${providerUsername}`, error);
                                }
                            }
                        }

                        else if (googleUser && !nativeUser) {
                            console.log('✅ Only Google user exists. Using Google federated user.');
                            finalUsername = googleUser.Username;
                        }
                    } else {
                        console.log('🆕 No existing users found with this email. Proceeding as new Google user.');
                        finalUsername = providerUsername;
                    }



                    // 4. Set custom:empInfo if missing
                    try {
                        const userData = await cognitoISP.adminGetUser({
                            UserPoolId: process.env.REACT_APP_COGNITO_USERPOOLID,
                            Username: finalUsername,
                        }).promise();

                        console.log("finalUsername", userData)

                        const hasEmpInfo = userData.UserAttributes.some(
                            attr => attr.Name === 'custom:empInfo'
                        );

                        if (!hasEmpInfo) {
                            await GoogleCustomattribute(finalUsername, name);
                            console.log('✅ Set custom:empInfo');
                        }
                    } catch (err) {
                        console.error('❌ Error checking/setting custom attributes:', err);
                    }

                    const result = await getUserDetailsFromCognito(finalUsername);
                    if (!result.success) {
                        stopHudRotation();
                        return;
                    }

                    localStorage.setItem('isLoggedIn', 'true')
                    if (result.isApproved && result.isActive) {
                        onLogin(result.email);
                        stopHudRotation();
                        navigate('/Referrals', { replace: true });
                    } else {
                        stopHudRotation();
                        navigate('/AccessDenied', { replace: true });
                    }
                } else {
                    console.error('Token exchange failed:', data);
                    stopHudRotation();
                }
            } catch (err) {
                console.error('Error exchanging code:', err);
                stopHudRotation();
            } finally {
                stopHudRotation();
            }
        };

        handleOAuth();
    }, []);


    const handleEmailChange = (e) => {
        const value = e.target.value;
        setEmail(value);
        validateEmail(value);
    };

    const handlePasswordChange = (e) => {
        const value = e.target.value;
        setPassword(value);
        validatePassword(value);
    };

    const validateEmail = (value) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        setEmailErrorMessage(emailRegex.test(value) ? '' : 'Enter a valid email address.');
    };

    const validatePassword = (value) => {
        const isValid = /.{8,}/.test(value) && /\d/.test(value) &&
            /[\W_]/.test(value) && /[A-Z]/.test(value) && /[a-z]/.test(value);
        setPasswordErrorMessage(isValid ? '' :
            'Password must contain at least 8 characters including numbers, symbols, uppercase, and lowercase letters.');
    };

    const toggleShowPassword = () => setShowPassword(!showPassword);
    const handleCheckboxChange = () => setIsChecked(!isChecked);

    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     // onLogin(email);
    //     navigate('/AccessDenied');
    // };



    const handleSubmit = async (e) => {
        e.preventDefault();

        // Clear previous error messages
        setEmailErrorMessage('');
        setPasswordErrorMessage('');

        // Validate fields
        validateEmail(email);
        validatePassword(password);

        // Check for any errors
        if (!email || !password || emailErrorMessage || passwordErrorMessage) {
            return;
        }

        // Proceed with sign-in logic if valid
        const user = new CognitoUser({
            Username: email,
            Pool: UserPool,
        });
        hud("Please Wait...")
        try {
            const authDetails = new AuthenticationDetails({
                Username: email,
                Password: password,
            });

            const userData = await cognitoISP.adminGetUser({
                UserPoolId: process.env.REACT_APP_COGNITO_USERPOOLID,
                Username: email,
            }).promise();
            localStorage.setItem('UserStatus', userData.UserStatus);

            await new Promise((resolve, reject) => {
                user.authenticateUser(authDetails, {
                    onSuccess: (data) => {
                        user.getUserAttributes((err, attributes) => {
                            if (err) {
                                stopHudRotation();
                                console.error('Error fetching user attributes:', err);
                                handleFailure('Error fetching user attributes');
                            } else {
                                stopHudRotation();

                                localStorage.setItem('isUserLoggedIn', true);
                                localStorage.setItem('email', email);
                                localStorage.setItem('attributes', JSON.stringify(attributes));
                                const empInfoAttr = attributes.find(attr => attr.Name === 'custom:empInfo');
                                if (empInfoAttr) {
                                    try {
                                        const empInfo = JSON.parse(empInfoAttr.Value);
                                        // Save full empInfo object
                                        localStorage.setItem('employeeInfo', JSON.stringify(empInfo));
                                        // Save individual fields
                                        if ('isEmployeeApproved' in empInfo) {
                                            localStorage.setItem('isEmployeeApproved', empInfo.isEmployeeApproved.toString());
                                        }

                                        if ('accessLevel' in empInfo) {
                                            localStorage.setItem('accessLevel', empInfo.accessLevel.toString());
                                        }

                                        if ('isEmployeeActive' in empInfo) {
                                            localStorage.setItem('isEmployeeActive', empInfo.isEmployeeActive.toString());
                                        }

                                        if ('name' in empInfo) {
                                            localStorage.setItem('employeeName', empInfo.name);
                                        }


                                    } catch (e) {
                                        console.error('Failed to parse empInfo:', e);
                                    }
                                }


                                // console.log('attributes', attributes)
                                if (isChecked) {
                                    localStorage.setItem('rememberMe', 'true');
                                    localStorage.setItem('rememberedEmail', email);
                                    localStorage.setItem('rememberedPassword', password);
                                } else {
                                    localStorage.removeItem('rememberMe');
                                    localStorage.removeItem('rememberedEmail');
                                    localStorage.removeItem('rememberedPassword');
                                }
                                const isApproved = localStorage.getItem('isEmployeeApproved') === 'true';
                                const isActive = localStorage.getItem('isEmployeeActive') === 'true';
                                const useremail = localStorage.getItem("email");
                                const accessLevel = parseInt(localStorage.getItem("accessLevel"), 10);
                                const userName = useremail?.split('@')[0];

                                if (isApproved && isActive) {
                                    onLogin(email);
                                    navigate('/Referrals');
                                    insertLog(
                                        `${userName} successfully signed in and navigated to Referrals screen.`,
                                        0,
                                        useremail,
                                        hud,
                                        stopHudRotation
                                    );

                                }
                               else {
                                    navigate("/AccessDenied");
                                }

                            }
                        });
                        resolve();
                    },
                    onFailure: (err) => {
                        console.error('Authentication failure:', err);
                        handleFailure(err.message);
                        reject(err);
                        stopHudRotation();
                    },
                });
            });
        } catch (error) {
            handleCatchError(error);
            stopHudRotation();
            showAlert(error.message, [
                { label: 'Ok', color: 'var(--buttonColor)', onClick: () => { } }
            ]);
        }
    };

    const handleFailure = (message) => {
        stopHudRotation();
        showAlert(message, [
            { label: 'Ok', color: 'var(--buttonColor)', onClick: () => { } }
        ]);
        localStorage.setItem('isUserLoggedIn', false);
    };

    const handleCatchError = (error) => {
        if (error.response) {
            console.error('Response Error:', error.response.data);
        } else if (error.request) {
            console.error('Request Error:', error.request);
        } else {
            console.error('Error:', error.message);
        }
        stopHudRotation();
    };

    const handleGoogleLogin = () => {
        const clientId = process.env.REACT_APP_COGNITO_CLIENTID;
        const domain = "us-east-1z0mtkhk91.auth.us-east-1.amazoncognito.com";
         const redirectUri = "https://refer.sharkunlock.com"; // or your local URI
        //const redirectUri = "http://localhost:3000"; // or your production URI

        const responseType = 'code';
        const scope = 'openid profile email';

        const queryParams = new URLSearchParams({
            identity_provider: 'Google',
            redirect_uri: redirectUri,
            response_type: responseType,
            client_id: clientId,
            scope: scope,
            prompt: 'select_account'
        });

        window.location.href = `https://${domain}/oauth2/authorize?${queryParams.toString()}`;

    };


    return (
        <div className='centered-content container d-flex flex-column align-items-center login-hub'>
            <span className="heading-span mb-2"><img src="/logo.png" alt="email" /></span>
            <span className='font-weight-bold mb-3 logo'>
                Welcome to Referral Manager. Please sign in to your account.
            </span>
            <div className='input-container mb-3 w-100'>
                <div className='d-flex justify-content-center w-100'>
                    <form onSubmit={handleSubmit} className='form-container'>
                        <div className='form-group mb-3'>
                            <input
                                className={`form-control ${emailErrorMessage ? 'is-invalid' : email ? 'is-valid' : ''} inputs`}
                                type='text'
                                placeholder='Email'
                                value={email}
                                onChange={handleEmailChange}
                            />
                            {emailErrorMessage && <div className='invalid-feedback error-message'>{emailErrorMessage}</div>}
                        </div>
                        <div className='form-group'>
                            <div className='password-container'>
                                <input
                                    className={`form-control ${passwordErrorMessage ? 'is-invalid' : password ? 'is-valid' : ''} inputs`}
                                    type={showPassword ? 'text' : 'password'}
                                    placeholder='Password'
                                    value={password}
                                    onChange={handlePasswordChange}
                                />
                                <span
                                    className='password-toggle-icon'
                                    onClick={toggleShowPassword}
                                    style={{ right: passwordErrorMessage ? '40px' : '10px' }}
                                >
                                    {showPassword ? <FaRegEye className='pass-eye' /> : <FaRegEyeSlash />}
                                </span>
                                {passwordErrorMessage && <div className='invalid-feedback error-message'>{passwordErrorMessage}</div>}
                            </div>
                        </div>

                        <div className='d-flex justify-content-between align-items-center mb-3'>
                            <div className='form-check'>
                                <input
                                    className='form-check-input'
                                    type='checkbox'
                                    id='checkbox-text'
                                    checked={isChecked}
                                    onChange={handleCheckboxChange}
                                    style={{ cursor: 'pointer' }}
                                />
                                <label className='form-check-label' htmlFor='checkbox-text'>
                                    Remember Me
                                </label>
                            </div>
                            <Link to="/ForgotPassword" className="text-decoration-underline customs-link">
                                Forgot Password?
                            </Link>
                        </div>

                        <button className='btn btn-primary submit btn-block mt-1 submit-button' type='submit'>
                            Sign In
                        </button>
                    </form>
                </div>
            </div>

            {/* Google Login Button */}

            <div className=" text-center mt-1">
                <button
                    className="mb-2 google-btn "
                    onClick={handleGoogleLogin}

                >
                    <img
                        src="https://developers.google.com/identity/images/g-logo.png"
                        alt="Google"
                        style={{ width: '20px', marginRight: '10px', verticalAlign: 'middle' }}
                    />
                    Continue with Google
                </button>
            </div>
            {/* <div className="OR-line"><div className="line"></div><div className="NameOR">OR</div><div className="line"></div></div> */}
            <div className='form-group mb-3 text-center'>
                <p>
                    Don't have an account?{' '}
                    <Link to="/SignUp" className="text-decoration-underline custom-link2">
                        Sign Up
                    </Link>
                </p>
            </div>
        </div>
    );
}

export default SignIn;
